import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { PageType, type NestedPage } from '../../../services/fourwaves/models';

@Component
export default class WebsiteNavigationLinkMixin extends Vue {
  @Prop({ type: Object, required: true }) page!: NestedPage;
  @Prop({ type: Number, default: 0 }) tabIndex!: number;
  @Prop({ type: Boolean, default: false }) readOnly!: boolean;

  get rootTagName(): string {
    if (this.readOnly) return 'div';
    return this.isNativeLink ? 'a' : 'NuxtLink';
  }

  get rootAttributes(): Record<string, string> {
    if (this.readOnly) return {};
    if (this.isNativeLink) return { href: this.pageLink };
    return { to: this.pageLink };
  }

  get rootTabIndex(): number {
    if (this.readOnly) return -1;
    return this.tabIndex;
  }

  get pageLink(): string {
    if (this.readOnly) return '';

    const routeMap: Partial<Record<PageType, { name: string }>> = {
      [PageType.Home]: { name: 'slug-pages-id' },
      [PageType.Registration]: { name: 'slug-registration' },
      [PageType.Submission]: { name: 'slug-submission' },
      [PageType.Schedule]: { name: 'slug-schedule' },
      [PageType.Abstracts]: { name: 'slug-abstracts' },
      [PageType.Participants]: { name: 'slug-participants' },
    };

    const route = routeMap[this.page.type] || { name: 'slug-pages-id', params: { id: this.page.id } };
    return this.localePath(route);
  }

  get isNativeLink(): boolean | undefined {
    if (this.readOnly) return;

    // We need to force a fresh page load to clear the form's state
    const isConfirmationRoute = this.$route.path.endsWith('/confirmation');
    const isRegistration = this.$route.name?.includes('registration') && this.page.type === PageType.Registration;
    const isSubmission = this.$route.name?.includes('submission') && this.page.type === PageType.Submission;
    return isConfirmationRoute && (isRegistration || isSubmission);
  }
}
